"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H1"));

var _PhoneSupport = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/PhoneSupport"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _responsiveBreakpoints = _interopRequireDefault(require("pricing-pages-unified-ui/utils/responsiveBreakpoints"));

function _templateObject9() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    line-height: 1.37;\n    font-size: 2.18em;\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    width: auto;\n    line-height: 1.4;\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      font-size: 1.5em;\n      font-weight: 600;\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n        margin-top: 2.5em;\n      "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n        padding: 0;\n        text-align: left;\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      width: auto;\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      display: block;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    margin: 3.5em auto 60px;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    justify-content: space-between;\n    margin: 2.37em auto;\n    position: relative;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledFlex = (0, _styledComponents.default)(_UIFlex.default).withConfig({
  displayName: "PhoneSupportFooter__StyledFlex",
  componentId: "sc-9uhq5h-0"
})(["margin:140px auto 125px;", " ", " &.phone-support-footer{", "}.phone-support-footer__tel{width:350px;", " .phone-support-container{", " ", "}}.phone-heading{", "}*{z-index:1;}"], _responsiveBreakpoints.default.tablet(_templateObject()), _responsiveBreakpoints.default.phone(_templateObject2()), _responsiveBreakpoints.default.tabletPortrait(_templateObject3()), _responsiveBreakpoints.default.tablet(_templateObject4()), _responsiveBreakpoints.default.tabletPortrait(_templateObject5()), _responsiveBreakpoints.default.phone(_templateObject6()), _responsiveBreakpoints.default.tablet(_templateObject7()));
var StyledHeading = (0, _styledComponents.default)(_H.default).withConfig({
  displayName: "PhoneSupportFooter__StyledHeading",
  componentId: "sc-9uhq5h-1"
})(["width:70%;", " ", ""], _responsiveBreakpoints.default.tablet(_templateObject8()), _responsiveBreakpoints.default.phone(_templateObject9()));

function PhoneSupportFooter(_ref) {
  var phoneSourceId = _ref.phoneSourceId,
      screen = _ref.screen;
  return _react.default.createElement(StyledFlex, {
    grow: 2,
    className: "phone-support-footer",
    align: "center",
    justify: "center"
  }, _react.default.createElement(StyledHeading, {
    "data-selenium-id": "phone-support-footer-header"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.pages.crm.stillHaveQuestions"
  })), _react.default.createElement("div", {
    grow: 1,
    className: "phone-support-footer__tel"
  }, _react.default.createElement(_PhoneSupport.default, {
    screen: screen,
    className: "phone-support-footer__contents",
    phoneSourceId: phoneSourceId,
    showCopy: false,
    border: false
  })));
}

PhoneSupportFooter.propTypes = {
  phoneSourceId: _propTypes.default.string.isRequired,
  screen: _propTypes.default.string.isRequired
};
var _default = PhoneSupportFooter;
exports.default = _default;
module.exports = exports.default;